import {isDevEnvironment, isTestEnvironment} from 'appShell/Layout/Navigation';
import React, {useMemo} from 'react';

export const useDashboardUtils = () => {
	const isTestDashboard = useMemo(
		(): boolean => isTestEnvironment() || isDevEnvironment(),
		[],
	);

	return {isTestDashboard};
};
